import AddIcon from "@mui/icons-material/Add";
import { Chip, Stack, Tooltip } from "@mui/material";
import type { CustomerHasFilter } from "@przezmorze/api-types";
import type { FC } from "react";
import { PREDEFINED_FILTERS } from "../clientFilters";
import { filterChipSx } from "./filterChipSx";

interface Props {
  applied: CustomerHasFilter[];
  onAdd: (value: CustomerHasFilter) => void;
}

/** The predefined filters not applied yet; an applied one is shown among the active filters instead. */
const PredefinedFilterChips: FC<Props> = ({ applied, onAdd }) => {
  const available = PREDEFINED_FILTERS.filter((filter) => !applied.includes(filter.value));

  return (
    <Stack
      role="group"
      aria-label="Dostępne filtry"
      direction="row"
      spacing={0.75}
      useFlexGap
      sx={{ flexWrap: "wrap", alignItems: "center" }}
    >
      {available.map((filter) => (
        <Tooltip key={filter.value} title={filter.description} describeChild>
          <Chip
            label={filter.label}
            size="small"
            icon={<AddIcon />}
            onClick={() => onAdd(filter.value)}
            sx={filterChipSx}
          />
        </Tooltip>
      ))}
    </Stack>
  );
};

export default PredefinedFilterChips;
